/* ==========================================================================
   firefly-mega-nav.js
   Firefly 自定义 header 的移动抽屉交互
   复刻 done 主题移动抽屉的核心行为：
   - 点汉堡按钮：滑入抽屉（body 加 firefly-mega-nav-open）
   - 点一级带子菜单的项：展开二级面板（.navigation__item--open + drawer--child-open）
   - 点返回 / 关闭 / 遮罩：收起
   桌面下拉同样由本脚本控制：首次展开按面板高度计算卷帘时长；
   菜单之间旧面板留在原位当底板、新面板叠在上方展开，不重新收起。
   ========================================================================== */
(function () {
  'use strict';

  var BODY_OPEN_CLASS = 'firefly-mega-nav-open';
  var DRAWER_CHILD_OPEN_CLASS = 'firefly-mobile-drawer--child-open';
  var ITEM_OPEN_CLASS = 'navigation__item--open';
  var TAP_CLOSED_CLASS = 'firefly-mega-nav__item--tap-closed';
  var SWITCHING_CLASS = 'is-switching';
  var TAP_STORAGE_KEY = 'firefly-mega-nav:tapped-at';
  var activeTapRelease = null;
  var MOBILE_SEARCH_OPEN_CLASS = 'is-search-open';
  var MOBILE_SEARCH_ONLY_CLASS = 'firefly-mobile-drawer--search-only';

  /* 指针是否仍停留在任一菜单触发器或“真正展开中”的面板范围内。
     两个关键排除，否则指针在页面任意位置都被判成“还在菜单上”、
     点击抑制永不解除，表现为菜单点击后 hover 不开、要点一下才有反应：
     - 被抑制（tap-closed）的面板已收起：clip-path/visibility 只是视觉隐藏，
       DOM 矩形仍罩着视口大片区域，不能计入；
     - 面板仅在对应 item 仍处于 hover 时才算展开中；收起中/已收起的面板
       不参与命中测试（visibility:hidden），鼠标即使悬在其矩形内也不会令
       item:hover 成立，matches(':hover') 即可区分。 */
  function isPointerOverMegaNav(clientX, clientY) {
    var items = document.querySelectorAll('.firefly-nav .navigation__item--with-children');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var rect = item.getBoundingClientRect();
      if (
        clientX >= rect.left && clientX <= rect.right &&
        clientY >= rect.top && clientY <= rect.bottom
      ) return true;

      if (item.classList.contains(TAP_CLOSED_CLASS)) continue;
      if (!item.matches(':hover')) continue;

      for (var c = 0; c < item.children.length; c++) {
        if (!item.children[c].classList.contains('navigation__tier-2-container')) continue;
        var panelRect = item.children[c].getBoundingClientRect();
        if (
          clientX >= panelRect.left && clientX <= panelRect.right &&
          clientY >= panelRect.top && clientY <= panelRect.bottom
        ) return true;
      }
    }
    return false;
  }

  function releaseTapClosed() {
    var closed = document.querySelectorAll('.' + TAP_CLOSED_CLASS);
    for (var i = 0; i < closed.length; i++) {
      closed[i].classList.remove(TAP_CLOSED_CLASS);
    }
    try { window.sessionStorage.removeItem(TAP_STORAGE_KEY); } catch (error) { /* 隐私模式等场景忽略 */ }
    if (activeTapRelease) {
      document.removeEventListener('mousemove', activeTapRelease, true);
      activeTapRelease = null;
    }
  }

  /* 挂“真实移动”监听。origin 为空时（整页跳转后的新文档没有点击坐标），
     以第一帧 mousemove 作为基准。解除必须同时满足：
     1. 距基准 400ms 以上——盖住点击瞬间的手部微动与滚动动画派发的合成 mousemove；
     2. 距基准坐标位移 24px 以上——合成 mousemove 坐标不变，微动远小于该值；
     3. 指针已离开整个菜单区（含面板）——鼠标还悬在菜单上时解除，
        :hover 会立即把面板重新展开，正是“收回后又弹开”的来源。 */
  function armTapRelease(origin) {
    if (activeTapRelease) {
      document.removeEventListener('mousemove', activeTapRelease, true);
    }
    var pending = origin || null;
    activeTapRelease = function (moveEvt) {
      if (!pending) {
        pending = { x: moveEvt.clientX, y: moveEvt.clientY, at: Date.now() };
        return;
      }
      if (Date.now() - pending.at < 400) return;
      if (
        Math.abs(moveEvt.clientX - pending.x) < 24 &&
        Math.abs(moveEvt.clientY - pending.y) < 24
      ) return;
      if (isPointerOverMegaNav(moveEvt.clientX, moveEvt.clientY)) return;
      releaseTapClosed();
    };
    document.addEventListener('mousemove', activeTapRelease, true);
  }

  /* 整页跳转场景：点击菜单链接跳到新页面后，tap-closed 类随旧文档销毁，
     指针仍悬在菜单上会让新页面一加载就把面板 hover 展开。
     通过 sessionStorage 把“刚点击过菜单”带到新文档：5 秒内先全部抑制，
     等鼠标真实移动且离开菜单区后再恢复常规 hover（见 armTapRelease）。 */
  function initDesktopTapSuppression() {
    var tappedAt = 0;
    try {
      tappedAt = parseInt(window.sessionStorage.getItem(TAP_STORAGE_KEY), 10) || 0;
    } catch (error) { /* 读取失败视为没有标记 */ }

    if (!tappedAt || Date.now() - tappedAt >= 5000) return;

    var items = document.querySelectorAll('.firefly-nav .navigation__item--with-children');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.add(TAP_CLOSED_CLASS);
    }
    armTapRelease(null);
  }

  function init(root) {
    if (!root || root.__fireflyNavInit) return;
    root.__fireflyNavInit = true;

    // 滚动切换：顶部透明，滚过阈值后加 is-scrolled（白底黑字）。
    // 放在 drawer guard 之前，保证任何情况下都会绑定。
    initScrollState(root);
    initAccountDialogPosition(root);
    initSearchMegaPosition(root);
    initDesktopMegaWidth(root);
    initDesktopTapSuppression();
    initLanguagePicker(root);

    var drawer = root.querySelector('#firefly-mobile-drawer');
    var backdrop = root.querySelector('.firefly-mega-nav__backdrop');
    if (!drawer) return;

    var title = drawer.querySelector('.firefly-mobile-drawer__title');
    var mobileSearch = drawer.querySelector('[data-firefly-mobile-search]');
    var mobileSearchComponent = mobileSearch ? mobileSearch.querySelector('predictive-search-component') : null;
    var mobileSearchInput = mobileSearch ? mobileSearch.querySelector('[data-firefly-mobile-search-input]') : null;
    var mobileSearchReturnFocus = null;
    var mobileSearchOpenedStandalone = false;

    function syncMobileSearchTop() {
      if (!mobileSearch) return;
      var top;

      if (mobileSearchOpenedStandalone) {
        top = Math.max(0, root.getBoundingClientRect().bottom);
      } else {
        var announcement = drawer.querySelector('.firefly-mobile-drawer__announcement');
        var header = drawer.querySelector('.firefly-mobile-drawer__header');
        top = (announcement ? announcement.offsetHeight : 0) + (header ? header.offsetHeight : 0);
      }

      mobileSearch.style.setProperty('--firefly-mobile-search-top', Math.round(top) + 'px');
    }

    function setMobileSearchTriggersExpanded(expanded) {
      root.querySelectorAll('[data-firefly-mobile-search-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function openMobileSearch(trigger) {
      if (!mobileSearch) return;
      mobileSearchReturnFocus = trigger || document.activeElement;
      mobileSearchOpenedStandalone = !document.body.classList.contains(BODY_OPEN_CLASS);

      if (mobileSearchOpenedStandalone) {
        drawer.classList.add(MOBILE_SEARCH_ONLY_CLASS);
        drawer.setAttribute('aria-hidden', 'false');
      }

      syncMobileSearchTop();
      mobileSearch.classList.add(MOBILE_SEARCH_OPEN_CLASS);
      mobileSearch.setAttribute('aria-hidden', 'false');
      setMobileSearchTriggersExpanded(true);

      window.requestAnimationFrame(function () {
        if (mobileSearchInput) mobileSearchInput.focus();
      });
      window.setTimeout(function () {
        if (mobileSearch.classList.contains(MOBILE_SEARCH_OPEN_CLASS) && mobileSearchInput) {
          mobileSearchInput.focus();
        }
      }, 340);
    }

    function closeMobileSearch(restoreFocus) {
      if (!mobileSearch || !mobileSearch.classList.contains(MOBILE_SEARCH_OPEN_CLASS)) return;
      mobileSearch.classList.remove(MOBILE_SEARCH_OPEN_CLASS);
      mobileSearch.setAttribute('aria-hidden', 'true');
      setMobileSearchTriggersExpanded(false);

      if (mobileSearchComponent && typeof mobileSearchComponent.resetSearch === 'function') {
        mobileSearchComponent.resetSearch(false);
      }

      if (mobileSearchOpenedStandalone) {
        drawer.classList.remove(MOBILE_SEARCH_ONLY_CLASS);
        drawer.setAttribute('aria-hidden', 'true');
        mobileSearchOpenedStandalone = false;
      }

      if (restoreFocus) {
        if (mobileSearchReturnFocus && mobileSearchReturnFocus.isConnected) {
          mobileSearchReturnFocus.focus();
        }
      }
      mobileSearchReturnFocus = null;
    }

    function openDrawer() {
      closeMobileSearch(false);
      document.body.classList.add(BODY_OPEN_CLASS);
      drawer.setAttribute('aria-hidden', 'false');
      syncMobileSearchTop();
      if (backdrop) backdrop.hidden = false;
      var toggle = root.querySelector('[data-firefly-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      closeMobileSearch(false);
      document.body.classList.remove(BODY_OPEN_CLASS);
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(DRAWER_CHILD_OPEN_CLASS);
      collapseAll();
      if (backdrop) backdrop.hidden = true;
      var toggle = root.querySelector('[data-firefly-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function collapseAll() {
      drawer.querySelectorAll('.' + ITEM_OPEN_CLASS).forEach(function (el) {
        el.classList.remove(ITEM_OPEN_CLASS);
        el.querySelectorAll('[aria-expanded="true"]').forEach(function (a) {
          a.setAttribute('aria-expanded', 'false');
        });
      });
      if (title) title.textContent = '';
    }

    /* 打开某个一级项的二级面板（手风琴原地展开） */
    function openItem(item) {
      // 关闭其它已展开的一级项
      drawer.querySelectorAll('.navigation__tier-1 > .' + ITEM_OPEN_CLASS).forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove(ITEM_OPEN_CLASS);
          openItem.querySelectorAll('[aria-expanded="true"]').forEach(function (a) {
            a.setAttribute('aria-expanded', 'false');
          });
        }
      });

      item.classList.add(ITEM_OPEN_CLASS);
      item.querySelectorAll('.navigation__link[aria-controls], .navigation__children-toggle[aria-controls]').forEach(function (a) {
        a.setAttribute('aria-expanded', 'true');
      });
    }

    function backToTopLevel() {
      collapseAll();
    }

    /* 打开抽屉的汉堡按钮 */
    root.querySelectorAll('[data-firefly-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        openDrawer();
      });
    });

    /* 手机搜索保留导航抽屉，通过菜单内部遮罩显示搜索层。 */
    root.querySelectorAll('[data-firefly-mobile-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        openMobileSearch(btn);
      });
    });

    root.querySelectorAll('[data-firefly-mobile-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        closeMobileSearch(true);
      });
    });

    /* 关闭：X 按钮 / 遮罩 */
    root.querySelectorAll('[data-firefly-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        closeDrawer();
      });
    });

    /* 展开菜单中的账户入口也使用 Shopify 官方账户组件。
       内部账户抽屉打开后先关闭导航抽屉，避免两个全屏抽屉叠加。 */
    var drawerAccount = drawer.querySelector('[data-firefly-drawer-account]');
    if (drawerAccount) {
      drawerAccount.addEventListener('click', function () {
        closeDrawer();
      });
    }

    /* 返回：从二级面板回到一级列表 */
    root.querySelectorAll('[data-firefly-drawer-back]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        backToTopLevel();
      });
    });

    /* 委托：点击一级带子菜单项的 链接 / 展开箭头 → 展开二级 */
    drawer.addEventListener('click', function (evt) {
      var trigger = evt.target.closest(
        '.navigation__tier-1 > .navigation__item--with-children > .navigation__link, ' +
        '.navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle'
      );
      if (!trigger || !drawer.contains(trigger)) return;

      var item = trigger.closest('.navigation__item--with-children');
      if (!item || !item.parentElement || !item.parentElement.classList.contains('navigation__tier-1')) return;

      evt.preventDefault();

      if (item.classList.contains(ITEM_OPEN_CLASS)) {
        // 再次点击当前已展开项：收起
        item.classList.remove(ITEM_OPEN_CLASS);
        item.querySelectorAll('[aria-expanded="true"]').forEach(function (a) {
          a.setAttribute('aria-expanded', 'false');
        });
      } else {
        openItem(item);
      }
    });

    /* PC mega 面板是纯 CSS :hover 展开；点击面板内链接后（软切换或整页跳转）
       指针往往仍悬在菜单上，面板会立刻被 :hover 重新展开。
       点击时挂 tap-closed 抑制类立即收起，并把点击时间写入 sessionStorage
       供整页跳转后的新文档复用（见 initDesktopTapSuppression）；
       之后由 armTapRelease 在“鼠标真实移动且已离开整个菜单区”时解除。
       判定不能用 mouseleave：滚动/布局变化会断开 hover 链，误派发 mouseleave。 */
    document.addEventListener('click', function (evt) {
      // 点击一级菜单标题（非面板内容）：立即解除点击抑制，恢复常规 hover。
      // 这是抑制期间的明确恢复入口——鼠标点一下标题即可重新展开面板
      if (!evt.target.closest('.navigation__tier-2-container')) {
        if (evt.target.closest('.firefly-nav .navigation__item--with-children')) {
          releaseTapClosed();
        }
        return;
      }

      var link = evt.target.closest('.navigation__tier-2-container a[href]');
      if (!link) return;

      var item = link.closest('.navigation__item--with-children');
      if (!item) return;

      item.classList.add(TAP_CLOSED_CLASS);
      try {
        window.sessionStorage.setItem(TAP_STORAGE_KEY, String(Date.now()));
      } catch (error) { /* 隐私模式等场景忽略，仅影响整页跳转后的抑制 */ }
      armTapRelease({ x: evt.clientX, y: evt.clientY, at: Date.now() });
    });

    /* Esc 关闭 */
    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape') return;

      if (mobileSearch && mobileSearch.classList.contains(MOBILE_SEARCH_OPEN_CLASS)) {
        closeMobileSearch(true);
        return;
      }

      if (document.body.classList.contains(BODY_OPEN_CLASS)) {
        closeDrawer();
      }
    });

    window.addEventListener('resize', syncMobileSearchTop, { passive: true });

    /* ====== 桌面 simple-dark-dropdown：列表 offset 对齐触发项 ======
       复刻 done 的 onProxyNavEnterSmallMenu 逻辑：
       offset = 触发项链接的 left - 内容盒 inner 的 left，
       写入 --simple-dark-dropdown-offset，使列表与橙竖线对齐触发项水平位置。 */
    initSimpleDarkOffsets(root);
    initDesktopNavState(root);
  }

  function initLanguagePicker(root) {
    var picker = root.querySelector('[data-language-picker]');
    if (!picker) return;
    var trigger = picker.querySelector('[data-language-trigger]');
    var menu = picker.querySelector('[data-language-menu]');
    if (!trigger || !menu) return;

    /* 展开状态由触发按钮的 aria-expanded 驱动 CSS 过渡动画(同巨幕菜单),不再切换 hidden */
    function isOpen() {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    function setOpen(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    trigger.addEventListener('click', function () {
      setOpen(!isOpen());
    });
    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      setOpen(true);
      var firstLink = menu.querySelector('a[href]');
      if (firstLink) firstLink.focus();
    });
    picker.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isOpen()) return;
      event.preventDefault();
      setOpen(false);
      trigger.focus();
    });
    picker.addEventListener('focusout', function (event) {
      if (!picker.contains(event.relatedTarget)) setOpen(false);
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) setOpen(false);
    });
    /* 鼠标离开胶囊/悬浮窗整体区域即收起，替代“点击外部关闭”——
       首页 hero 轮播是全屏链接，点击外部关闭容易误触跳转。
       胶囊与悬浮窗之间有 10px 空隙，立即关闭会打断移动路径，
       用 180ms 延迟桥接：重新进入（移入悬浮窗）会取消关闭。 */
    var closeTimer = 0;
    picker.addEventListener('mouseleave', function () {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        setOpen(false);
      }, 180);
    });
    picker.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      /* hover 胶囊即展开（mouseenter 仅鼠标触发，触屏不受影响） */
      setOpen(true);
    });
    document.addEventListener('click', function (event) {
      if (!picker.contains(event.target)) setOpen(false);
    });
  }

  /* ====== 桌面巨幕菜单可用视口宽度 ======
     Horizon 桌面端真正的滚动容器是 .page-wrapper，而不是 documentElement。
     使用它的 clientWidth 才能排除自身的竖向滚动条，避免巨幕菜单产生横向溢出。 */
  function initDesktopMegaWidth(root) {
    var frame = 0;
    var layoutViewport = root.closest('.page-wrapper') || document.querySelector('.page-wrapper');

    function update() {
      frame = 0;
      var viewportWidth = layoutViewport && layoutViewport.clientWidth
        ? layoutViewport.clientWidth
        : document.documentElement.clientWidth || window.innerWidth;
      var viewportWidthValue = Math.round(viewportWidth) + 'px';
      root.style.setProperty('--firefly-layout-viewport-width', viewportWidthValue);
      document.documentElement.style.setProperty('--firefly-layout-viewport-width', viewportWidthValue);
    }

    function scheduleUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
    }

    if (window.ResizeObserver) {
      var viewportObserver = new ResizeObserver(scheduleUpdate);
      viewportObserver.observe(layoutViewport || document.documentElement);
    }
  }

  /* ====== PC 搜索巨幕定位 ======
     search-modal 位于 document 末尾并进入浏览器 top layer，无法自然跟随 Header。
     打开前读取 Firefly Header 的实际底边，兼容顶部公告栏、吸顶和自定义高度。 */
  function initSearchMegaPosition(root) {
    var trigger = root.querySelector('[data-firefly-search-open]');
    if (!trigger) return;
    var dialog = document.querySelector('#search-modal .search-modal__content');

    var frame = 0;

    function update() {
      frame = 0;
      var rect = root.getBoundingClientRect();
      var top = Math.max(0, Math.round(rect.bottom));
      document.documentElement.style.setProperty('--firefly-search-dialog-top', top + 'px');
    }

    function scheduleUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    update();
    trigger.addEventListener('click', function () {
      update();
      scheduleUpdate();
    }, { capture: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);

    if (dialog && window.MutationObserver) {
      var dialogObserver = new MutationObserver(function () {
        if (dialog.open) scheduleUpdate();
      });
      dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(root);
    }
  }

  /* ====== PC 账户弹窗跟随账户图标 ======
     Shopify 默认把 account dialog 固定在视口右侧；宽屏时 Header 内容盒已经居中，
     两者会错开。根据账户图标的实际位置计算弹窗左边距，让图标位于弹窗正上方，
     同时把弹窗限制在视口安全边距内。 */
  function initAccountDialogPosition(root) {
    var account = root.querySelector('.firefly-mega-nav__desktop shopify-account.firefly-mega-nav__account-link');
    if (!account) return;

    var DESKTOP_BREAKPOINT = 990;
    var DIALOG_WIDTH = 360;
    var VIEWPORT_GUTTER = 30;
    var frame = 0;

    function update() {
      frame = 0;

      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        account.style.removeProperty('--firefly-account-dialog-inline-start');
        return;
      }

      var rect = account.getBoundingClientRect();
      var preferredLeft = rect.left + (rect.width / 2) - (DIALOG_WIDTH / 2);
      var maximumLeft = Math.max(VIEWPORT_GUTTER, window.innerWidth - DIALOG_WIDTH - VIEWPORT_GUTTER);
      var dialogLeft = Math.min(Math.max(VIEWPORT_GUTTER, preferredLeft), maximumLeft);

      account.style.setProperty('--firefly-account-dialog-inline-start', Math.round(dialogLeft) + 'px');
    }

    function scheduleUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    update();
    account.addEventListener('click', update, { capture: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(root);
      resizeObserver.observe(account);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  }

  /* ====== 桌面导航状态与卷帘展开 ======
     首次展开用 clip-path 做“向下拉开”的实心卷帘，时长按面板高度预量
     （clamp(高度 / 2, 360ms, 640ms)）；菜单之间切换时旧面板留在原位当底板、
     新面板叠在上方用略短的卷帘展开，不重新收起；离开整个菜单时再播放完整的
     收起卷帘，header 白底与面板同刻开始、同时结束。 */
  function initDesktopNavState(root) {
    var nav = root.querySelector('.firefly-mega-nav__nav');
    if (!nav) return;

    var actions = root.querySelector('.firefly-mega-nav__desktop .firefly-mega-nav__actions');
    var closeTimer;
    var switchTimer;
    var closingClassTimer;
    var durationFrame = 0;
    var closeDelay = 140;
    var minOpenDuration = 360;
    var maxOpenDuration = 640;
    var switchOpenDuration = 340;
    var items = Array.from(nav.querySelectorAll('.navigation__tier-1 > .navigation__item'));
    var panelDurations = new WeakMap();
    var activeItem = null;
    var switchBackdrop = null;
    var closingUntil = 0;

    function getPanel(item) {
      return item.querySelector(':scope > .navigation__tier-2-container');
    }

    /* 参考 Apple globalnav：展开时长随面板高度变化（高度 / 2），
       高度越大卷帘走得越久，再按实际观感把范围控制在 360–640ms。 */
    function measurePanelOpenDuration(item) {
      var panel = getPanel(item);
      if (!panel) return 0;

      var height = panel.getBoundingClientRect().height;
      if (!height) return 0;

      var duration = Math.round(Math.min(maxOpenDuration, Math.max(minOpenDuration, height / 2)));
      panelDurations.set(panel, duration);
      return duration;
    }

    function updatePanelOpenDurations() {
      durationFrame = 0;
      items.forEach(function (item) {
        measurePanelOpenDuration(item);
      });
    }

    function schedulePanelDurationUpdate() {
      if (durationFrame) return;
      durationFrame = window.requestAnimationFrame(updatePanelOpenDurations);
    }

    /* 首次展开优先用预量值，避免鼠标进入时同步读取布局；
       面板在初始化时不可见导致没量到时再补量一次。
       时长写到 header 根节点：面板卷帘与 header 白底共用同一个值。 */
    function applyPanelOpenDuration(item, explicitDuration) {
      var panel = getPanel(item);
      if (!panel) return;

      var duration = explicitDuration || panelDurations.get(panel) || measurePanelOpenDuration(item);
      if (!duration) return;
      panel.style.removeProperty('--firefly-panel-open-duration');
      root.style.setProperty('--firefly-panel-open-duration', duration + 'ms');
    }

    /* 立即隐藏某个面板（不播放收起动画），并清掉切换时写入的行内状态。
       先以 transition:none 落定关闭态，再把 transition 还原，避免下一帧
       又按收起过渡重新动起来。 */
    function hidePanelInstantly(item) {
      var panel = getPanel(item);
      if (!panel) {
        setExpanded(item, false);
        return;
      }
      panel.style.transition = 'none';
      setExpanded(item, false);
      void panel.offsetWidth;
      panel.style.transition = '';
      panel.style.removeProperty('--firefly-switch-clip');
      panel.style.removeProperty('--firefly-panel-open-duration');
    }

    function setExpanded(item, expanded) {
      item.classList.toggle('navigation__item--show-children', expanded);
      item.querySelectorAll(':scope > [aria-expanded]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function readTimeVar(element, name) {
      var raw = window.getComputedStyle(element).getPropertyValue(name).trim();
      var value = parseFloat(raw) || 0;
      if (raw.slice(-2) !== 'ms' && raw.slice(-1) === 's') value *= 1000;
      return value;
    }

    /* 收起动画的总时长（内容淡出的延迟 + 卷帘时长 + 40ms 缓冲），
       用于判断收起是否仍在进行，也决定 header 何时开始淡回透明 */
    function closeWait() {
      return (
        readTimeVar(nav, '--firefly-mega-close-delay') +
        readTimeVar(nav, '--firefly-mega-close-duration') +
        40
      );
    }

    /* 透明 header 的卷帘衔接参数（仅首页透明态、未滚动、桌面宽度时生效）。
       面板段曲线 cubic-bezier(0.4,0,1,1) 末端斜率 1/0.6，header 段
       cubic-bezier(0,0,0.2,1) 起始斜率 1/0.2；令两段在交接处像素速度相等：
         (1/0.6)·D1/T1 = 5·D2/T2  =>  T2 = 3·D2·T1 / D1
       D1 = 面板高 + 40px 阴影余量，D2 = header 高。 */
    function getHeaderRoll(item) {
      if (root.getAttribute('data-transparent') !== 'true') return null;
      if (root.classList.contains('is-scrolled')) return null;
      if (window.innerWidth < 990) return null;

      var panel = getPanel(item);
      var desktop = root.querySelector('.firefly-mega-nav__desktop');
      if (!panel || !desktop) return null;

      var panelHeight = panel.getBoundingClientRect().height;
      var headerHeight = desktop.getBoundingClientRect().height;
      if (!panelHeight || !headerHeight) return null;

      var panelDuration = readTimeVar(nav, '--firefly-mega-close-duration');
      var duration = Math.round((3 * headerHeight * panelDuration) / (panelHeight + 40));
      duration = Math.min(220, Math.max(90, duration));
      return {
        delay: readTimeVar(nav, '--firefly-mega-close-delay') + panelDuration,
        duration: duration
      };
    }

    /* 透明 header 首次展开的接力参数：header 段匀速（斜率 1）拉到下沿，
       面板段延后到此刻起步，曲线 cubic-bezier(0.3,0.3,0.2,1) 起始斜率也是 1；
       令交接处像素速度相等：H / Th = (P + 40) / Tp  =>  Th = H·Tp / (P + 40)。
       收起途中重新进入时 header 白底仍在，直接按原逻辑展开，不再接力。 */
    function getHeaderOpenRoll(item) {
      if (root.getAttribute('data-transparent') !== 'true') return null;
      if (root.classList.contains('is-scrolled')) return null;
      if (window.innerWidth < 990) return null;
      if (Date.now() < closingUntil) return null;

      var panel = getPanel(item);
      var desktop = root.querySelector('.firefly-mega-nav__desktop');
      if (!panel || !desktop) return null;

      var panelHeight = panel.getBoundingClientRect().height;
      var headerHeight = desktop.getBoundingClientRect().height;
      var panelDuration = panelDurations.get(panel) || measurePanelOpenDuration(item);
      if (!panelHeight || !headerHeight || !panelDuration) return null;

      var duration = Math.round((headerHeight * panelDuration) / (panelHeight + 40));
      return { duration: Math.min(140, Math.max(70, duration)) };
    }

    function setPanelOpenRoll(roll) {
      if (roll) {
        root.style.setProperty('--firefly-header-roll-open-duration', roll.duration + 'ms');
        root.style.setProperty('--firefly-panel-open-delay', roll.duration + 'ms');
        root.style.setProperty('--firefly-panel-open-ease', 'cubic-bezier(0.3, 0.3, 0.2, 1)');
      } else {
        root.style.removeProperty('--firefly-panel-open-delay');
        root.style.removeProperty('--firefly-panel-open-ease');
      }
    }

    /* 切换到另一块巨幕：旧面板不收，保持原样垫在下面；新面板加 is-switch-target
       叠到上方，用 340ms 卷帘在旧面板表面展开，看起来是同一块面板在换内容。
       新面板更矮时把旧面板底边同步收到新高度，避免下方露出一段旧背景。 */
    function startSwitch(previous, item) {
      nav.classList.add(SWITCHING_CLASS);
      items.forEach(function (candidate) {
        candidate.classList.remove('is-switch-target');
        if (
          candidate !== previous &&
          candidate !== item &&
          candidate.classList.contains('navigation__item--show-children')
        ) {
          hidePanelInstantly(candidate);
        }
      });
      item.classList.add('is-switch-target');
      item.style.removeProperty('--firefly-switch-clip');
      applyPanelOpenDuration(item, switchOpenDuration);

      var oldPanel = getPanel(previous);
      var newPanel = getPanel(item);
      if (oldPanel && newPanel) {
        var oldHeight = oldPanel.getBoundingClientRect().height;
        var newHeight = newPanel.getBoundingClientRect().height;
        oldPanel.style.setProperty('--firefly-panel-open-duration', switchOpenDuration + 'ms');
        if (newHeight && oldHeight && newHeight < oldHeight) {
          oldPanel.style.setProperty(
            '--firefly-switch-clip',
            'inset(0 -40px ' + Math.round(oldHeight - newHeight) + 'px -40px)'
          );
        } else {
          oldPanel.style.removeProperty('--firefly-switch-clip');
        }
      }

      switchBackdrop = previous;
      switchTimer = window.setTimeout(function () {
        endSwitch(item);
      }, switchOpenDuration + 40);
    }

    function endSwitch(item) {
      var backdrop = switchBackdrop;
      switchBackdrop = null;
      if (backdrop && backdrop !== item) hidePanelInstantly(backdrop);
      nav.classList.remove(SWITCHING_CLASS);
      item.classList.remove('is-switch-target');
    }

    function showPanel(item, handoff) {
      window.clearTimeout(switchTimer);
      window.clearTimeout(closingClassTimer);
      root.classList.remove('is-menu-closing');

      var previous = activeItem;
      var keepBackdrop = handoff && previous && previous !== item;

      if (keepBackdrop) {
        /* 菜单之间切换时 header 已是白底，面板直接展开，不接力 */
        setPanelOpenRoll(null);
        startSwitch(previous, item);
      } else {
        setPanelOpenRoll(getHeaderOpenRoll(item));
        if (switchBackdrop) {
          hidePanelInstantly(switchBackdrop);
          switchBackdrop = null;
        }
        nav.classList.remove(SWITCHING_CLASS);
        /* 首次展开：用按面板高度预量的卷帘时长 */
        applyPanelOpenDuration(item);
      }

      activeItem = item;
      closingUntil = 0;
      items.forEach(function (candidate) {
        if (candidate === item) {
          setExpanded(candidate, true);
          return;
        }
        if (keepBackdrop && candidate === previous) return;
        /* 从收起途中重新进入：把还在收/已收的面板立即落定，避免残影 */
        if (handoff) hidePanelInstantly(candidate);
        else setExpanded(candidate, false);
      });
      root.classList.add('is-menu-open');
    }

    function closePanels(keepNavHover) {
      window.clearTimeout(closeTimer);
      window.clearTimeout(switchTimer);
      if (switchBackdrop) {
        hidePanelInstantly(switchBackdrop);
        switchBackdrop = null;
      }
      nav.classList.remove(SWITCHING_CLASS);
      var now = Date.now();
      if (activeItem) {
        var waitTotal = closeWait();
        var colorSwitchAt = waitTotal;
        var roll = getHeaderRoll(activeItem);
        if (roll) {
          /* 透明 header：面板段收完后由 CSS 延迟接上 header 段卷帘；
             文字颜色在卷帘边缘扫过文字附近时切回白色 */
          root.style.setProperty('--firefly-header-roll-delay', roll.delay + 'ms');
          root.style.setProperty('--firefly-header-roll-duration', roll.duration + 'ms');
          waitTotal = roll.delay + roll.duration + 40;
          colorSwitchAt = roll.delay + Math.round(roll.duration * 0.35);
        }
        closingUntil = now + waitTotal;
        activeItem = null;
        /* 收起期间 header 保持深色文字（is-menu-closing 沿用白底规则） */
        root.classList.add('is-menu-closing');
        window.clearTimeout(closingClassTimer);
        closingClassTimer = window.setTimeout(function () {
          root.classList.remove('is-menu-closing');
        }, colorSwitchAt);
      }
      items.forEach(function (item) {
        item.classList.remove('is-switch-target');
        setExpanded(item, false);
      });
      root.classList.remove('is-menu-open');
      if (!keepNavHover) root.classList.remove('is-nav-hover');
    }

    function activate(item) {
      window.clearTimeout(closeTimer);
      root.classList.add('is-nav-hover');

      if (!item.classList.contains('navigation__item--with-children')) {
        closePanels(true);
        return;
      }

      if (item === activeItem) {
        root.classList.add('is-menu-open');
        return;
      }

      /* 已有面板打开时旧面板留在原位当底板；仍在收起时直接用新面板接上 */
      showPanel(item, !!activeItem || Date.now() < closingUntil);
    }

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (
          nav.matches(':hover') ||
          nav.contains(document.activeElement) ||
          (actions && (actions.matches(':hover') || actions.contains(document.activeElement)))
        ) return;
        closePanels(false);
      }, closeDelay);
    }

    nav.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      root.classList.add('is-nav-hover');
    });
    nav.addEventListener('mouseleave', scheduleClose);

    /* 右侧账户 / 搜索 / 购物车与菜单共享 Header hover 状态。
       从菜单移向图标时收起下拉，但保持透明 Header 的白底黑字。 */
    if (actions) {
      actions.addEventListener('mouseenter', function () {
        closePanels(true);
        root.classList.add('is-nav-hover');
      });
      actions.addEventListener('mouseleave', scheduleClose);
      actions.addEventListener('focusin', function () {
        closePanels(true);
        root.classList.add('is-nav-hover');
      });
      actions.addEventListener('focusout', scheduleClose);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activate(item);
      });
      item.addEventListener('focusin', function () {
        activate(item);
      });
      item.addEventListener('focusout', scheduleClose);
    });

    /* 启动时先量好各面板高度；字体、图片、窗口尺寸变化后重新预量，
       避免 hover 展开的那一刻才同步读取布局。 */
    schedulePanelDurationUpdate();
    window.addEventListener('load', schedulePanelDurationUpdate);
    window.addEventListener('pageshow', schedulePanelDurationUpdate);
    window.addEventListener('resize', schedulePanelDurationUpdate, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedulePanelDurationUpdate);
    }
    if (window.ResizeObserver) {
      var panelObserver = new ResizeObserver(schedulePanelDurationUpdate);
      items.forEach(function (item) {
        var panel = getPanel(item);
        if (panel) panelObserver.observe(panel);
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-nav-hover')) {
        closePanels(false);
      }
    });

    var searchTrigger = root.querySelector('[data-firefly-search-open]');
    if (searchTrigger) {
      searchTrigger.addEventListener('click', function () {
        closePanels(false);
      });
    }
  }

  function initSimpleDarkOffsets(root) {
    var nav = root.querySelector('.firefly-mega-nav__nav');
    if (!nav) return;

    var items = nav.querySelectorAll('.navigation__item--simple-dark-dropdown');

    function updateOffset(item) {
      var dropdown = item.querySelector(':scope > .navigation__tier-2-container');
      if (!dropdown) return;
      var inner = dropdown.querySelector('.simple-dark-dropdown__inner');
      var link = item.querySelector(':scope > .navigation__link');
      if (!inner || !link) return;
      var innerLeft = inner.getBoundingClientRect().left;
      var linkLeft = link.getBoundingClientRect().left;
      var offset = Math.max(0, Math.round(linkLeft - innerLeft));
      dropdown.style.setProperty('--simple-dark-dropdown-offset', offset + 'px');
    }

    items.forEach(function (item) {
      // 悬停时（打开前）计算，保证首次展开就对齐
      item.addEventListener('mouseenter', function () {
        updateOffset(item);
      });
      // 键盘聚焦时同样处理
      item.addEventListener('focusin', function () {
        updateOffset(item);
      });
    });

    // 视口尺寸变化时，清掉旧值（下次 hover 重新计算）
    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        var dropdown = item.querySelector(':scope > .navigation__tier-2-container');
        if (dropdown) dropdown.style.removeProperty('--simple-dark-dropdown-offset');
      });
    }, { passive: true });
  }

  /* ====== 滚动切换：顶部透明，滚过阈值后 is-scrolled（白底黑字） ======
     直接读取实际滚动位置，兼容 window、document.scrollingElement 和主题里的
     自定义滚动容器。避免 IntersectionObserver 哨兵在 sticky/display:contents
     组合下始终被判断为可见，导致 Header 无法恢复白底。 */
  function initScrollState(root) {
    var SCROLLED_CLASS = 'is-scrolled';
    var THRESHOLD = 8;
    var pageWrapper = root.closest('.page-wrapper');
    var ticking = false;

    /** @param {boolean} scrolled */
    function setScrolled(scrolled) {
      root.classList.toggle(SCROLLED_CLASS, !!scrolled);
    }

    function getDocumentScrollTop() {
      return Math.max(
        window.scrollY || 0,
        window.pageYOffset || 0,
        document.documentElement ? document.documentElement.scrollTop || 0 : 0,
        document.body ? document.body.scrollTop || 0 : 0,
        document.scrollingElement ? document.scrollingElement.scrollTop || 0 : 0
      );
    }

    function apply() {
      ticking = false;
      setScrolled(Math.max(getDocumentScrollTop(), pageWrapper ? pageWrapper.scrollTop : 0) > THRESHOLD);
    }

    function onScroll(event) {
      var target = event && event.target;
      // 下拉菜单、抽屉等局部区域的滚动不改变页头底色。
      if (target && target !== document && target !== window && target !== pageWrapper &&
          target !== document.documentElement && target !== document.body &&
          target !== document.scrollingElement) return;

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('pageshow', apply);
    window.addEventListener('resize', apply, { passive: true });
  }

  function boot() {
    document.querySelectorAll('firefly-mega-nav').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify 主题编辑器中 section 重载后重新初始化
  document.addEventListener('shopify:section:load', boot);
})();
